import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { UserPreferencesApi } from './user-preferences-api';
import { Select } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { UserService } from '../../../services/user-service';
import { AsyncPipe } from '@angular/common';
import { TimeZone } from '../../../pages/admin/timezones/timezone-interface';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-user-preferences',
  imports: [
    Select,
    FormsModule,
    AsyncPipe
  ],
  templateUrl: './user-preferences.html',
  styleUrl: './user-preferences.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserPreferences implements OnInit {
  private api = inject(UserPreferencesApi);
  public userService = inject(UserService);

  timezones: Observable<TimeZone[]>;

  ngOnInit() {
    this.timezones = this.api.fetchTimezones();
  }

  setTimezone(timezone: TimeZone) {
    this.userService.updateUserTimezone(timezone);
  }
}
